import qs from "qs";
import axios from "utils/axios";

import { API } from "constants/";

// Type
import { AxiosResponse } from "axios";
import {
    ClientHubByIdResponse,
    ClientHubCreationPayload,
    ClientHubCreationResponse,
    ClientHubResponse,
    ClientHubUsersResponse,
    PermissionsRefResponse,
    RoleBundleResponse,
    UsersCanAddResponse,
} from "./clienthub.types";

export type TClientHubFiltersPayload = {
    filter_name: string;
    filter_roles_ld: string[];
    filter_roles_pace: string[];
    order_by: string;
    page_size: number;
    page_no: number;
};

export type TClientHubUsersFiltersPayload = {
    filter_name: string;
    filter_functions: string[];
    clientHub: ClientHubByIdResponse;
    order_by: string;
    page_size: number;
    page_no: number;
};

export const clientHubFilters = {
    filter_name: "",
    filter_roles_ld: [""],
    filter_roles_pace: [""],
    order_by: "name,asc",
    page_size: 10,
    page_no: 1,
};

export const usersForClientHubFilters = {
    filter_user_name: "",
    filter_company_name: "",
    order_by: "name,asc",
    page_size: 10,
    page_no: 1,
};

export const clientHubUsersFilters = {
    order_by: "name,asc",
    page_size: 10,
    page_no: 1,
};

export const fetchClientHub = (
    filters: Partial<TClientHubFiltersPayload> = clientHubFilters
): Promise<AxiosResponse<ClientHubResponse>> => {
    return axios.get(`${API.SYSADMIN.CLIENT_HUB}?${qs.stringify(filters, { arrayFormat: "repeat" })}`);
};

export const createClientHub = (
    payload: ClientHubCreationPayload
): Promise<AxiosResponse<ClientHubCreationResponse>> => {
    return axios.post(API.SYSADMIN.ORG, payload);
};

export const updateClientHub = (
    orgId: number,
    payload: {
        name?: string;
        pay_wall_role_masks: string[];
    }
): Promise<AxiosResponse<ClientHubCreationResponse>> => {
    return axios.patch(`${API.SYSADMIN.ORG}/${orgId}`, payload);
};

export const getSelectableUsersForClientHub = (
    org_id: number,
    filters: Partial<typeof usersForClientHubFilters> = usersForClientHubFilters
): Promise<AxiosResponse<UsersCanAddResponse>> => {
    return axios.get(
        `${API.SYSADMIN.CLIENT_HUB}/${org_id}/users_can_add?${qs.stringify(filters, { arrayFormat: "repeat" })}`
    );
};

export const fetchClientHubByOrgId = (org_id: number): Promise<AxiosResponse<ClientHubByIdResponse>> =>
    axios.get(API.SYSADMIN.GET_CLIENT_HUB(org_id));

export const fetchClientHubUsersByOrdgId = (
    org_id: number,
    filters: Partial<TClientHubUsersFiltersPayload> = clientHubUsersFilters
): Promise<AxiosResponse<ClientHubUsersResponse>> =>
    axios.get(`${API.SYSADMIN.GET_CLIENT_HUB(org_id)}/users?${qs.stringify(filters, { arrayFormat: "repeat" })}`);

// PERMISSIONS (ROLES)
export const fetchPermissionsRef = (
    filter: "ALL" | "LD" | "PACE" = "ALL"
): Promise<AxiosResponse<PermissionsRefResponse>> => {
    return axios.get(`${API.SYSADMIN.PERMISSIONS_REF}?filter_roles=${filter}`);
};

export const fetchPermissionsRefBundle = (
    filter: "ALL" | "LD" | "PACE" = "ALL"
): Promise<AxiosResponse<RoleBundleResponse>> => {
    return axios.get(`${API.SYSADMIN.PERMISSIONS_REF_BUNDLE}?filter_role_bundles=${filter}`);
};
